<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-auto">
        <el-form-item
          :label="L10n('title')"
          prop="title"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.title"
            @input="form.title = valueTrimLeft($event)"
            @change="updateModelItem('title', { required: true })"/>
        </el-form-item>
      </div>
      <div class="col-12">
        <el-form-item
          :label="L10n('email-content')"
          prop="emailContent"
          class="material-style"
        >
          <skill-editor
            :model.sync="form.emailContent"
            @blur="updateModelItem('emailContent')"
          />
        </el-form-item>
      </div>
      <div class="col-12">
        <el-form-item
          :label="L10n('remarks')"
          prop="remarks"
          class="material-style"
        >
          <skill-editor
            :model.sync="form.remarks"
            @blur="updateModelItem('remarks')"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormInvoiceTypes',
  mixins: [Form],
  components: {
    'skill-editor': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/SkillEditor')
  }
}
</script>
